import React from "react";

import { Modal, ModalTitle } from "react-bootstrap";
import { useStateContext, currentMode } from "../../contexts/ContextProvider";
const UserRole = ({
  showModal,
  closeModel,
  openAddUserForm,
  openRoleManagementForm,
}) => {
  const { currentColor, currentMode } = useStateContext();

  return (
    <Modal
      show={showModal}
      // onHide={() => {
      //   closeModel();
      // }}
      size="sm"
      centered
      backdrop="static"
      keyboard={false}
      className="modal-dialog-centered ml-2 userRole"
    >
      <Modal.Header
        className={`  ${
          currentMode === "Dark"
            ? "text-white bg-[#33373E]"
            : "bg-white-200 "
        }`}
        // closeButton
        style={{ borderRadius: "none", }}
        
      ><Modal.Title className="w-full">  <div className="flex justify-end " onClick={closeModel}>
      <span
        style={{
          mask: `url(/icons/close.svg) center no-repeat`,
          WebkitMask: `url(/icons/close.svg) center no-repeat`,
          maskSize: "contain", // Adjust the mask size here
          WebkitMaskSize: "contain",
          display: "block",
          width: "25px",
          height: "25px",
          backgroundColor: currentColor,
          transition: "background-color 0.3s",
          marginRight: "8px",
          cursor: "pointer",
        }}
      ></span>
    </div></Modal.Title>
      </Modal.Header>
      <Modal.Body className={`overflow-auto p-6 ${
            currentMode === "Dark"
              ? "text-white bg-[#33373E]"
              : "bg-white"
          }`}>
        <div className="flex items-center justify-center space-x-4 ">
          <div
            className=" "
            style={{
              borderColor: currentColor,
              backgroundColor: currentColor,
            }}
          >
            <button
              className="flex flex-col items-center p-6  transition-all duration-300 hover:bg-[#86a4eb] hover:text-blue-500 focus-within:bg-blue-50/50 focus-within:ring-1 focus:bg-blue-50/50 focus-within:ring-inset focus-within:ring-blue-600"
              onClick={openAddUserForm}
            >
              <span
                className="block w-[130px] h-[100px] mr-[5px] bg-white onhover"
                style={{
                  mask: `url(/icons/add-user.svg) center no-repeat`,
                  WebkitMask: `url(/icons/add-user.svg) center no-repeat`,
                  maskSize: "contain",
                  WebkitMaskSize: "contain",
                  transition: "background-color 0.3s",
                  backgroundColor: "white",
                }}
              ></span>

              <span className="mt-2 break-words text-white ">Add User</span>
            </button>
          </div>

          <div
            className="flex flex-col items-center  "
            style={{
              borderColor: currentColor,
              backgroundColor: currentColor,
            }}
          >
            <button
              className="flex flex-col items-center p-6  transition-all duration-300 hover:bg-[#86a4eb] focus-within:bg-blue-50/50 focus-within:ring-1 focus:bg-blue-50/50 focus-within:ring-inset focus-within:ring-blue-600" 
              onClick={openRoleManagementForm}
            >
              <span
                className="onhover"
                style={{
                  mask: `url(/icons/Add-user-role.svg) center no-repeat`,
                  WebkitMask: `url(/icons/Add-user-role.svg) center no-repeat`,
                  maskSize: "contain", // Adjust the mask size here
                  WebkitMaskSize: "contain",
                  display: "block",
                  width: "130px",
                  height: "100px",
                  marginRight: "5px",
                  backgroundColor: "white",
                  transition: "background-color 0.3s",
                }}
              ></span>
              {/* <RoleManagementIcon /> */}
              <span className="mt-2  custom-form-label break-words text-white">
                Role management
              </span>
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UserRole;
